module.exports = new __parcel__URL__("../frondosa.e154cd66.png").toString();